import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material';
import { useFormik } from 'formik';
import React from 'react'
import { useUpdateColorMutation } from '../../features/fullApi';

export default function EditDialog({openEdit, setOpenEdit, handleUpdateColor, item}) {

    const user = JSON.parse(localStorage.getItem('user'))
    const [updateColor] = useUpdateColorMutation()

    const onSubmit = async(values, actions) => {
          updateColor({_id: item._id, colorName: values.colorName }, { 
          headers: {
              'Token': `Bearer ${user?.accessToken}`
          }
          }, {id: item._id})
          .then(res => {
            console.log("res is")
          })
          .catch((e) => {
          console.log("e is", e)
          })
      }
      
      const {
        values,
        errors,
        touched,
        isSubmitting,
        handleBlur,
        handleChange,
        handleSubmit,
        setFieldValue,
      } = useFormik({
        initialValues: {
          colorName: item?.colorName,
        },
        onSubmit,
      });

    return (
        <form onSubmit={handleSubmit} >
            <Dialog aria-labelledby='dialog-title' onClose={() => setOpenEdit(false)} open={openEdit}>
                <DialogTitle id='dialog-title'>
                    Edit Color
                </DialogTitle>
                <DialogContent>
                    <DialogContentText style={{color: "red"}}>You are editing {item?.colorName}</DialogContentText>
                    <TextField
                        id="colorName"
                        type="text"
                        margin="dense"
                        value={values.colorName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label={values.colorName ? "" : "Color"}
                    />
                    {errors.colorName && touched.colorName && (
                        <p className="error">{errors.colorName}</p>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button
                        color="secondary"
                        onClick={() => setOpenEdit(false)}
                        variant="contained"
                    >Cancel</Button>
                    <Button
                        color="primary"
                        onClick={() => handleUpdateColor({id: item, colorName: values.colorName})}
                        variant="contained"
                        >Yes</Button>
                </DialogActions>
            </Dialog>
        </form>
    )
}